<template>
  <SkeletonLoader v-if="!items?.length" rounded />
  <dashboard-card
    v-for="item in items"
    :key="item.label"
    :number="item.count"
    :description="item.label"
    :class="[
      selectedStatus === item.label ? '!bg-blue-400' : '!bg-white',
      'min-w-[200px] flex w-full flex-col shadow-lg rounded-lg p-4 mb-6 mx-2 cursor-pointer',
    ]"
    :data-test-id="`card-content-${item.label}`"
    @click.prevent="setSelectedStatus(item.label)"
  >
    <template v-if="iconLookupFunction" #icon>
      <component :is="iconLookupFunction(item.label)?.value" v-bind="item.props" />
    </template>
  </dashboard-card>
</template>
<script setup>
import DashboardCard from "./DashboardCard.vue";
import SkeletonLoader from "@/components/shared/loaders/BaseSkeletonLoader.vue";

const emit = defineEmits(["select-status"]);
const setSelectedStatus = (status) => {
  emit("select-status", status);
};
const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  iconLookupFunction: {
    type: Function,
    default: () => {},
  },
  selectedStatus: {
    type: String,
    required: false,
    default: "",
  },
});
</script>
